export const ProcessingTimes = "/processingtimes";
export const CycleTimes = "/cycletimes";
export const WipCosts = "/wipcosts";
export const Wip = "/wip";
export const SpaceCosts = "/spacecosts";
export const Productivity = "/productivity";


// WEBPACK FOOTER //
// ./src/Logic/resultResources.js